module.exports = __webpack_public_path__ + "static/media/1.419b1384.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/images/9023/1.jpg
// module id = 871
// module chunks = 0